/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React, { useRef, useState } from 'react';

import HeaderText, { HeaderTextVariants } from 'components/HeaderText';
import useWindowWidth from 'hooks/browser/useWindowWidth';

import BeneficialOwnerCollectionPanel from 'containers/Payments/BeneficialOwnerCollectionPanel';

import greenCheckmark from 'public/images/icons/green-checkmark.svg?url';
import BodyText from 'components/BodyText';

import {
  MailToCustomerSupport
} from 'config/messageLinks';

import BlueHeaderOnWhiteLayout from 'layouts/BlueHeaderOnWhite';


export const InvalidBeneficialOwnerLandingPage = () => {
  const windowWidth = useWindowWidth();
  return (
    <BlueHeaderOnWhiteLayout
      contentWidth={windowWidth > 650 ? 650 : 'auto'}
      hideLinks={true}
    >
      <div className="viewstrap">
        <div className="text-center">
          <HeaderText className="pad-12-bottom">
            This is link no longer valid
          </HeaderText>
          <HeaderText className="pad-12-bottom" variant={HeaderTextVariants.Small}>
            Reach out to our {MailToCustomerSupport('support team')} if you need assistance
            changing your company information.
          </HeaderText>
        </div>
      </div>
    </BlueHeaderOnWhiteLayout>
  );
};

function BeneficialOwnerEntry({
  companyName,
  secureToken
}) {
  const panelRef = useRef();
  const [isComplete, setComplete] = useState(false);

  if (isComplete) {
    return (
      <div>
        <div className="text-center pad-20-top">
          <div className="pad-20">
            <img src={greenCheckmark} />
          </div>
          <HeaderText className="pad-20-bottom">
            Beneficial Ownership Information has been updated for {companyName}.
          </HeaderText>
          <BodyText>
            If you have any additional questions,
            please contact our {MailToCustomerSupport('support team')}.
          </BodyText>
        </div>
      </div>
    );
  }

  return (
    <div className="pad-20-x">
      <HeaderText className="pad-12-bottom">
        Beneficial Ownership Information for {companyName}
      </HeaderText>

      {/* <HeaderText className="pad-12-bottom" variant={HeaderTextVariants.Small}>
        Please review our Payment Terms and accept them below to receive card payments from <strong>
          {customerCompany}
        </strong>.
      </HeaderText> */}

      <br/><br/>

      <BeneficialOwnerCollectionPanel ref={panelRef} showSubmit={true}
        secureToken={secureToken}
        onComplete={(success) => {
          if (success) {
            setComplete(true);
          }
        }} />

      <br /><br />

      <HeaderText className="pad-12-bottom" variant={HeaderTextVariants.Small}>
        If you have any questions, please contact our {MailToCustomerSupport('support team')}.
      </HeaderText>

    </div>
  );
}


// This page also does double duty to also service the 'resend my digits' action
const BenefialOwnerLandingPage = ({
  context,
  secureToken,
  secureTokenContext: {
    data: {
      companyName
    }
  }
}) => {
  const windowWidth = useWindowWidth();


  return (
    <BlueHeaderOnWhiteLayout
      contentWidth={windowWidth > 1000 ? 1000 : 'auto'}
      hideLinks={true}>
      <div className="viewstrap">
        <BeneficialOwnerEntry companyName={companyName}
          secureToken={secureToken} />
      </div>
    </BlueHeaderOnWhiteLayout>
  );
};

export default BenefialOwnerLandingPage;